import React from 'react'
import CustomLink from './CustomLink'

class MDBDropdownItem extends React.Component {
  render() {
    return (
      <div>
        {this.props.href ? (
          <CustomLink link={this.props.href} className={this.props.className}>
            <span className="dropdown-text">{this.props.children}</span>
          </CustomLink>
        ) : (
          <span className={this.props.className}>{this.props.children}</span>
        )}
      </div>
    );
  }
}

export default MDBDropdownItem